import React, { useCallback, useEffect, useState } from 'react';
import { Tab } from '@mui/material';
import { HeadlessPageWrapper } from 'templates/PageWrapper/PageWrapper';
import { StyledPaper } from 'pages/ContactsPage/Contacts.styles';
import { StyledTabList } from 'molecules/Card/Card.styles';
import { StyledTabPanel } from 'organisms/CompanyInvoicesTabs/CompanyInvoicesTabs.styles';
import { TabContext, TabPanel } from '@mui/lab';
import CloudOpsReport from 'organisms/CloudOpsReport/tabs/CloudOpsReport';
import SecurityReport from 'organisms/CloudOpsReport/tabs/SecurityReports';
import ObservabilityReport from 'organisms/CloudOpsReport/tabs/Observability';
import axios from 'axios';
import { ICompany } from 'organisms/Companies/types';
import { useBaoSelector } from 'utils/hooks/redux';
import { OrgCostReport } from 'organisms/OrgReportPDF/types';

type TabType = 'projectInvoicing' | 'securityReports' | 'infraObservability';

export type OrgReport = {
  ConnectorID: string;
  ConnectorName: string;
  ID: number;
  OrganizationID: string;
  Report: OrgCostReport;
};

const CloudOpsReportPage = () => {
  const { currentCompany } = useBaoSelector((state) => state.common);

  const [selectedTab, setSelectedTab] = useState<TabType>('projectInvoicing');
  const [company, setCompany] = useState<ICompany>();

  const handleChangeTabs = useCallback(
    (event: React.SyntheticEvent, newValue: TabType) => {
      setSelectedTab(newValue);
    },
    []
  );

  useEffect(() => {
    if (!currentCompany) return;
    (() => {
      axios
        .get(
          `${process.env.REACT_APP_USER_SERVICE}/company/${currentCompany.company_hs_id}`
        )
        .then((p) => {
          setCompany(p.data);
        });
    })();
  }, []);

  function a11yProps(index: number) {
    return {
      id: `tab-${index}`,
      'aria-controls': `tabpanel-${index}`,
    };
  }

  return (
    <HeadlessPageWrapper>
      <StyledPaper sx={{ minWidth: '1150px !important' }}>
        <TabContext value={selectedTab}>
          <StyledTabList
            onChange={handleChangeTabs}
            aria-label="CloudOps Reports tabs"
            variant="fullWidth"
          >
            <Tab
              label="Project Invoicing"
              {...a11yProps(1)}
              className={selectedTab === 'projectInvoicing' ? '.active' : ''}
              value="projectInvoicing"
            />
            {/* <Tab
              label="Security Reports"
              {...a11yProps(0)}
              className={selectedTab === 'securityReports' ? '.active' : ''}
              value="securityReports"
            /> */}
            <Tab
              label="Infrastructure Observability"
              {...a11yProps(0)}
              className={selectedTab === 'infraObservability' ? '.active' : ''}
              value="infraObservability"
            />
          </StyledTabList>
          <StyledTabPanel value="projectInvoicing" sx={{ p: 0 }}>
            <CloudOpsReport />
          </StyledTabPanel>
          <TabPanel value="securityReports" sx={{ p: 0 }}>
            <SecurityReport />
          </TabPanel>
          <TabPanel value="infraObservability" sx={{ p: 0 }}>
            <ObservabilityReport
              connectorId={company?.fin_ops_gcp_connector_id}
            />
          </TabPanel>
        </TabContext>
      </StyledPaper>
    </HeadlessPageWrapper>
  );
};

export default CloudOpsReportPage;
